import { useQuery } from 'react-query'
import { axios } from '../../../lib'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from '../../../services/api/types'
import { OrdersPaymentTerms } from '../types'

type Data = PaginatedParams & {
  unityId?: string
}

const loadOrdersPaymentTerms = (
  data: PaginatedParams
): PaginatedResponse<OrdersPaymentTerms> => {
  const { page = 1, limit = 100 } = data
  return axios.get(`/orders/payment-terms`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderPaymentTerms(query: Data) {
  return useQuery(
    ['ordersPaymentTerms', query],
    () => loadOrdersPaymentTerms(query),
    {
      keepPreviousData: true,
      enabled: !!query.unityId,
      onError: () =>
        toast.error('Não foi possível carregar condições de pagamento!', {
          toastId: 'loadOrderPaymentTerm'
        })
    }
  )
}
